import React, { useState, useEffect } from 'react';

function PresetForm({ preset, onSave, onCancel }) {
  const [name, setName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (preset) {
      setName(preset.name || '');
      setFirstName(preset.first_name || '');
      setLastName(preset.last_name || '');
      setPhone(preset.phone || '');
      setIsActive(preset.is_active || false);
    }
  }, [preset]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await onSave({
        name,
        firstName,
        lastName,
        phone,
        isActive
      });

      if (!preset) {
        setName('');
        setFirstName('');
        setLastName('');
        setPhone('');
        setIsActive(false);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save card');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="preset-form" onSubmit={handleSubmit}>
      <h3 className="preset-form-title">
        {preset ? 'Edit card' : 'New card'}
      </h3>

      {error && <div className="error-message">{error}</div>}

      <div className="form-group">
        <label className="form-label" htmlFor="preset-name">Card label</label>
        <input
          id="preset-name"
          type="text"
          className="form-input"
          placeholder="Personal, Work, Business…"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <div className="form-hint">Only you see this label</div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label" htmlFor="preset-first">First name</label>
          <input
            id="preset-first"
            type="text"
            className="form-input"
            placeholder="John"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="preset-last">Last name</label>
          <input
            id="preset-last"
            type="text"
            className="form-input"
            placeholder="Doe"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="preset-phone">Phone number</label>
        <input
          id="preset-phone"
          type="tel"
          className="form-input"
          placeholder="+1 (555) 123-4567"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />
          <span>
            Make this the live card
            <span className="form-hint" style={{ display: 'block', marginTop: 0 }}>
              Your link will share this card
            </span>
          </span>
        </label>
      </div>

      <div className="form-actions">
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving…' : (preset ? 'Save changes' : 'Create card')}
        </button>
        <button type="button" className="btn btn-ghost" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}

export default PresetForm;
